import api from '../../api/home';
import router from '@/router/index.js';
const state = {
  user: {}
}
const getters = {
  userInfo: state => state.user
}
const actions = {
  getUserInfo({
    commit,
    state,
    username,
    num
  }) {
    return api.getUserInfo().then(res => {
      if (res.status == "200") {
        commit('setUser', res)
      } else {
        router.push('/login');
      }
    })
  }
}
const mutations = {
  setUser(state, userInfo) {
    state.user = userInfo
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js